import React from "react";

const NumberFormatter = ({ number }) => {
  const formatNumber = (num) => {
    const parsedNumber = Number(num);
    return new Intl.NumberFormat("en-IN").format(parsedNumber);
  };

  return <>{formatNumber(number)}</>;
};

export default NumberFormatter;
